// extracted by mini-css-extract-plugin
export var skipAnimation = "_32-0";